import React from 'react';

import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { Text } from '~/src/dash/components/text';
import { Col, Cols, Panel, PanelBreak, Panels, Row, Rows, spacing } from '~/src/dash/publicaUI';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { publicaColors } from '~/src/dash/utils/colors';
import { decorateV2 } from '~/src/dash/utils/decorator';
import { routeName } from '~/src/dash/utils/routes';
import { useBaseStore } from '~/src/dash/views//base/contexts';
import { iasDashboardConfig } from '~/src/dash/views/ias-publisher/config';
import { IASGlossaryRaw } from '~/src/dash/views/ias-publisher/IASGlossary/config';
const cfg = iasDashboardConfig;

interface IGlossaryContent {
  term: string;
  id: number;
  termId: number;
  definition: string;
  hierarchy: number;
  formula: string | null;
  tag: string;
}

const displayColumns = (contents: IGlossaryContent[]) => {
  const firstCol: IGlossaryContent[] = [];
  const secondCol: IGlossaryContent[] = [];
  const thirdCol: IGlossaryContent[] = [];
  contents.forEach((vocabulary, i: number) => {
    if (i % 3 === 0) {
      firstCol.push(vocabulary);
    } else if (i % 3 === 1) {
      secondCol.push(vocabulary);
    } else {
      thirdCol.push(vocabulary);
    }
  });
  return (
    <Cols style={{ justifyContent: 'space-around' }}>
      {[firstCol, secondCol, thirdCol].map((column) => {
        return (
          <Col style={{ width: '30%', margin: '0' }}>
            {column.map((vocabulary) => {
              return (
                <Rows extraSmallPadding>
                  <Row>
                    <Text subheader highlighted color={cfg.colors.turquoise}>
                      {vocabulary.term.toUpperCase()}
                    </Text>
                    <Text>{vocabulary.definition}</Text>
                  </Row>
                </Rows>
              );
            })}
          </Col>
        );
      })}
    </Cols>
  );
};

const _IASGlossary = () => {
  const { classes, location, session, user } = useBaseStore();
  const { pathname } = location;

  return (
    <Panels maxWidth vertical relative minWidthMain>
      <Panel
        largeHorizontalPadding
        verticalPadding
        paddingLeft='72px'
        style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
      >
        <ModelTopBar
          title={routeName(pathname)}
          session={session}
          user={user}
          publisher={session.publisher}
          classes={classes}
          delegateElevate={true}
          currentPath={pathname}
          disableTitlePaddingLeft
        />
      </Panel>
      <Panel scroll paddingTop={spacing.medium}>
        <Panels maxWidth vertical relative largeHorizontalPadding>
          {IASGlossaryRaw.map((content) => {
            return (
              <Panel paper marginBottom='18px'>
                <Rows>
                  <Row style={{ borderBottom: '1px solid #e0e6e9' }}>
                    <Text header>{content.header.toUpperCase()}</Text>
                  </Row>
                  {displayColumns(content.contents)}
                </Rows>
              </Panel>
            );
          })}
          <PanelBreak />
        </Panels>
      </Panel>
    </Panels>
  );
};

export const IASGlossary = decorateV2<Partial<ISessionState>>(cfg.defaultProps, _IASGlossary);
